module.exports = __webpack_public_path__ + "img/9925d38.jpg";